import React from 'react'
import PropTypes from 'prop-types'
import InnerHTML from 'dangerously-set-html-content'



const PageContent = ({ title, subtitle, content, parentSlug }) => {
  return (
    <React.Fragment>

      {title !== "Home" ?
      <h1>{title}</h1>
      : ''}
      
      <h2>{subtitle}</h2>

      {parentSlug && parentSlug.node.slug === "holiday-menu" ?
      <div class="yoast-breadcrumbs"><span><span><a href="/">Home</a> / <span><a href="/holiday-menu/">Holiday Menu</a> / <span class="breadcrumb_last" aria-current="page">{title}</span></span></span></span></div>
      : ''}

      <div className='page-content'>
        {content ? <InnerHTML html={content} /> : ''}
      </div>

    </React.Fragment>
  )
}

PageContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

export default PageContent;